<!--The content below is only a placeholder and can be replaced.-->
<ul id="tlyPageGuide" data-tourtitle="Novo menu do site Investment Services">
    <li class="tlypageguide_right" data-tourtarget=".first_element_to_target">
        <div class="guideText">
            O novo menu teve algumas telas renomeadas e está organizado pelas funcionalidades mais acessadas do site.
        </div>
    </li>
    <li class="tlypageguide_left" data-tourtarget=".second_element_to_target">
        <div class="guideText">
            Para conferir todas as outras telas do menu, é possível clicar em “menu completo” ou “ver todas as opções” de cada categoria.
        </div>
    </li>
    <li class="tlypageguide_left" data-tourtarget=".third_element_to_target">
        <div class="guideText">
            O site também conta com uma ferramenta de busca e sugestões de pesquisas do menu.
        </div>
    </li>


</ul>

<div class="tlyPageGuideWelcome">
    <div class="tlyguideWelcome">
        <span class="guideWelcome">Bem vindo ao novo menu do site <strong>Itaú Investment Services</strong></span>
        <br/>
        <br/>

        <span class="guideWelcomeText">Confira as principais novidades</span>
    </div>
    <div class="tlyguideButton">
        <button class="tlypageguide_start">iniciar</button>&nbsp;
        <button class="tlypageguide_ignore">pular</button>&nbsp;
        <button class="tlypageguide_dismiss">ok, entendi</button>
    </div>
</div>